import { Link } from 'react-router-dom';
import { OnboardingBlock, FormCol } from './OnboardingTemplate.styles';

function OnboardingTemplate({ children }) {
  return (
    <OnboardingBlock>
      <FormCol>
        <div className="form-content">
          <Link className="brand_logo" to="/">
            <span className="brand-mark">C</span>
            <span className="brand-name">Chrono Labs</span>
          </Link>
          {children}
        </div>
      </FormCol>
    </OnboardingBlock>
  );
}

export default OnboardingTemplate;
